// frontend/src/services/agent.ts
import { getApiUrl } from '../config/api';
import type {
  ProposalListItem,
  ProposalDetail,
} from '../types/agent';

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('access');
  const res = await fetch(getApiUrl(path), {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init.headers ?? {}),
    },
  });
  if (!res.ok) {
    throw new Error(`API ${path} -> ${res.status}: ${await res.text()}`);
  }
  return res.json();
}

export async function listProposals(
  status: 'pending' | 'approved' | 'rejected' | 'expired' = 'pending',
) {
  return request<{ results: ProposalListItem[] }>(
    `/api/agent/proposals/?status=${status}`,
  );
}

export async function getProposal(id: string) {
  return request<ProposalDetail>(`/api/agent/proposals/${id}/`);
}

export async function approveProposal(
  id: string,
  body: { action_ids?: string[]; payload_edits?: Record<string, any> } = {},
) {
  return request<{ status: string; actions: Array<{ action_id: string; status: string }> }>(
    `/api/agent/proposals/${id}/approve/`,
    { method: 'POST', body: JSON.stringify(body) },
  );
}

export async function rejectProposal(id: string) {
  return request<{ status: string }>(
    `/api/agent/proposals/${id}/reject/`,
    { method: 'POST' },
  );
}
